<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["preload", "loop", "muted"];
import { ref, watch, onMounted, inject, onBeforeUnmount } from "vue";
import {
  useElementVisibility,
  useEventListener,
  defaultWindow
} from "@vueuse/core";
import { usePlayerVideoApi } from "../composables/private/usePlayerVideoApi";
import { usePlayerMediaApi } from "../composables/private/usePlayerMediaApi";
import { usePlayerRuntime } from "../composables/private/usePlayerRuntime";
import { MagicPlayerInstanceId, MagicPlayerOptionsKey } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerVideo",
  setup(__props) {
    const injectedId = inject(MagicPlayerInstanceId, void 0);
    const injectedOptions = inject(MagicPlayerOptionsKey, void 0);
    if (!injectedId) {
      throw new Error("MagicPlayerVideo must be used within a MagicPlayerProvider");
    }
    if (!injectedOptions) {
      throw new Error("MagicPlayerVideo must be used within a MagicPlayerProvider");
    }
    const elRef = ref(void 0);
    const isVisible = useElementVisibility(elRef);
    const { initialize, destroy } = usePlayerRuntime({
      id: injectedId,
      mediaRef: elRef,
      src: injectedOptions.src,
      srcType: injectedOptions.srcType
    });
    const { muted, playing } = usePlayerMediaApi({
      id: injectedId,
      mediaRef: elRef
    });
    const { play, pause } = usePlayerVideoApi({
      id: injectedId,
      videoRef: elRef
    });
    function onWindowFocus() {
      if (isVisible.value && !playing.value && injectedOptions?.autoplay) {
        play();
      }
    }
    useEventListener(defaultWindow, "focus", onWindowFocus);
    watch(
      isVisible,
      (value) => {
        if (value && !playing.value && injectedOptions.autoplay) {
          play();
        } else if (!value && playing.value) {
          pause();
        }
      },
      {
        immediate: true
      }
    );
    onMounted(() => {
      initialize();
      if (injectedOptions.autoplay) {
        muted.value = true;
      }
    });
    onBeforeUnmount(() => {
      destroy();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("video", {
        ref_key: "elRef",
        ref: elRef,
        class: "magic-player-video",
        playsinline: "",
        disablePictureInPicture: "",
        preload: _unref(injectedOptions).preload,
        loop: _unref(injectedOptions).loop,
        muted: _unref(muted)
      }, null, 8, _hoisted_1);
    };
  }
});
</script>

<style>
.magic-player-video {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: cover;
}
</style>
